@for (child of block().children; track child._uid) {
    <li app-list-element [block]="child">
    </li>
}
